import { useQuery } from "@tanstack/react-query";
import { fetchSampleDetections } from "../../vmeAiApiClient/adapter";

const SampleDetectionGrid = ({
  lowering,
  phylum,
  starting_hour,
  ending_hour,
}: { lowering: string; phylum: string; starting_hour: number; ending_hour: number }) => {
  const {
    data: detectionImages,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["sampleDetections", lowering, phylum, starting_hour, ending_hour],
    queryFn: () => fetchSampleDetections(lowering, phylum, starting_hour, ending_hour),
    enabled: !!lowering && !!phylum,
    refetchOnWindowFocus: false,
  });

  if (isLoading) return <div>Loading detections...</div>;
  if (error) return <div>Error loading detections</div>;
  if (!detectionImages?.length) return <div>No {phylum} detections found</div>;

  return (
    <div className="mb-6 mt-6">
      <h4 className="mb-2 text-sm font-bold uppercase tracking-wide text-blue-100">
        Sample Hourly Detections
      </h4>
      <p className="mb-4 text-sm">
        Samples of frames the AI classified as {phylum} in each hour of the
        dive.
      </p>
      <div className="grid grid-cols-4 gap-4">
        {detectionImages.map((imagePath, index) => (
          <div key={index} className="aspect-square">
            <img
              src={imagePath}
              alt={`${phylum} detection ${index + 1}`}
              className="h-full w-full rounded-lg object-cover"
            />
            <p className="text-center text-xs">
              {imagePath.split("/")[5].split("_")[3].split(".")[0]}h
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SampleDetectionGrid;
